module.exports = __webpack_public_path__ + "static/media/ca.5678c787.svg";